import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import {
  AutoCompleteSelectionItem,
  IAutoCompleteService,
} from '../../../core/component/autocomplete-remote-paged/autocomplete-remote-paged.component';
import { AutoCompleteSelectionState } from '../../../core/component/autocomplete-remote/autocomplete-service.interface';
import { DataServiceBase } from '../../../core/service/base/data.service.base';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { ExecutorWebUser } from '../../model/executor-webuser';

function toAutoCompleteExecutorWebUserItem(executorUser: ExecutorWebUser): AutoCompleteSelectionItem<ExecutorWebUser> {
  const executor = new ExecutorWebUser(executorUser);
  const executorName = executor.toString();
  return new AutoCompleteSelectionItem(executorName, executorUser.id, executorUser);
}

abstract class ExecutorWebUserServiceBase extends DataServiceBase implements IAutoCompleteService<ExecutorWebUser, string> {
  constructor(endpoint: string, client: HttpClient, messageService: MessageService, progressBar: ProgressBarService, config: IAppConfig) {
    super(client, messageService, progressBar, config, endpoint);
  }

  getSelectionItem(id: string, state: AutoCompleteSelectionState): Observable<AutoCompleteSelectionItem<ExecutorWebUser> | null> {
    return super.getSelectionItemWithOptions<ExecutorWebUser>(id, state, toAutoCompleteExecutorWebUserItem);
  }

  getSelection(filter: string, options: string, page?: number): Observable<AutoCompleteSelectionItem<ExecutorWebUser>[]> {
    return super.getSelectionWithOptions<ExecutorWebUser, string>(filter, options, toAutoCompleteExecutorWebUserItem, page);
  }
}

@Injectable()
export class FaultNotificationExecutorService extends ExecutorWebUserServiceBase {
  constructor(client: HttpClient, messageService: MessageService, progressBar: ProgressBarService, @Inject(APP_CONFIG) config: IAppConfig) {
    super('fault-notification/executors', client, messageService, progressBar, config);
  }
}

@Injectable()
export class RoundingExecutorService extends ExecutorWebUserServiceBase {
  constructor(client: HttpClient, messageService: MessageService, progressBar: ProgressBarService, @Inject(APP_CONFIG) config: IAppConfig) {
    super('round-errand/executors', client, messageService, progressBar, config);
  }
}
